var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXM({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6667 46C36.3693 46 46.6667 35.7025 46.6667 23C46.6667 10.2975 36.3693 0 23.6667 0C10.9642 0 0.666748 10.2975 0.666748 23C0.666748 35.7025 10.9642 46 23.6667 46ZM31.1992 15.8397C32.2745 15.5158 33.2906 15.0207 34.2083 14.3734C33.8833 15.7081 33.1931 16.9259 32.215 17.8905C32.2651 18.1527 32.2908 18.419 32.2917 18.6859C32.2917 29.7067 21.75 34.4984 13.125 29.7067C15.5085 29.8015 17.8597 29.1298 19.8333 27.7901C11.2083 23.9567 15.0417 15.3317 15.0417 15.3317C16.0099 16.7104 17.304 17.8283 18.8089 18.5857C20.3137 19.3431 21.9825 19.7167 23.6667 19.673V18.7147C23.6549 17.8352 23.9135 16.9734 24.4074 16.2457C24.9014 15.518 25.607 14.9596 26.4287 14.646C27.2504 14.3324 28.1485 14.2787 29.0017 14.4922C29.8549 14.7057 30.622 15.176 31.1992 15.8397Z",
    fill: "#1E1619"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXM);
export default __webpack_public_path__ + "static/media/xM.c420679f3cb4e3bbdaa5445ab2de4b54.svg";
export { ForwardRef as ReactComponent };